export interface WorkshopUser {
  id: string;
  name: string;
  email: string;
  role?: string;
  group?: number;
}

export const addUserToWorkshop = async (workshopId: string, email: string, name: string): Promise<WorkshopUser> => {
  // Placeholder: Implement Firestore call
  console.log(`Adding user with email ${email} and name ${name} to workshop ${workshopId}`);
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  // Return a mock user
  return {
    id: `new-${Date.now()}`,
    name: name,
    email: email,
    role: 'Developer',
    group: Math.floor(Math.random() * 999) + 1
  };
};

export const removeUserFromWorkshop = async (workshopId: string, userId: string): Promise<void> => {
  // Placeholder: Implement Firestore call
  console.log(`Removing user ${userId} from workshop ${workshopId}`);
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
};

// Is realy needed?
export const getWorkshopUsers = async (workshopId: string): Promise<WorkshopUser[]> => {
  // Placeholder: Implement Firestore call
  console.log(`Fetching users for workshop ${workshopId}`);
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));

  return [
    { id: '1', name: 'Alice Johnson', email: 'alice@example.com', role: 'Developer', group: 12 },
    { id: '2', name: 'Bob Smith', email: 'bob@example.com', role: 'Business', group: 45 },
    { id: '3', name: 'Charlie Brown', email: 'charlie@example.com', role: 'UX', group: 99 },
  ];
};

export const commitWorkshopParticipantChanges = async (
  workshopId: string,
  additions: string[],
  removals: string[]
): Promise<void> => {
  console.log(`Committing changes for workshop ${workshopId}`);
  console.log(`Adding users: ${additions.join(', ')}`);
  console.log(`Removing users: ${removals.join(', ')}`);

  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
};
